import React from "react";

function ClothingIcon() {
  return (
    <>
      <path
        d="m 491.74744,293.68434 c -132.3279,78.68111 -348.07846,77.19931 -479.871585,-2.37428 26.507271,-31.18166 49.718458,-50.89992 63.862354,-60.8086 10.217021,-7.16272 20.929448,-13.59128 32.056641,-19.23728 l 3.76274,-1.85691 c 0.99364,-0.52125 2.01984,-1.00994 3.02975,-1.49861 8.55172,-4.05594 31.45397,-9.30097 50.67492,-15.42561 3.42067,-1.08593 6.67845,-2.17185 9.77338,-3.2578 v 0 c 7.3789,-2.72025 13.55239,-5.61968 17.05451,-8.63313 0.53771,-0.43623 1.03891,-0.91565 1.49858,-1.43343 0.875,-1.01576 1.65984,-2.10582 2.3456,-3.25779 l 44.59915,36.24289 6.90654,5.58714 v 0 l 6.22234,5.04953 6.25497,-4.21883 7.63952,-5.16358 v 0 l 38.6048,-26.06231 h 0.0815 l 17.26628,-11.69546 v 0 c 2.35401,2.93409 5.0936,5.53669 8.14448,7.73724 v 0 c 3.41712,2.4484 7.08681,4.5235 10.94617,6.18978 v 0 c 10.6041,4.77269 23.1466,7.91645 36.56869,14.15512 4.91926,2.28047 9.69735,4.6532 14.33426,7.11825 1.4823,0.78187 2.94832,1.6289 4.39803,2.3782 10.36446,5.6645 20.34901,11.99803 29.8902,18.96033 13.80794,9.92739 31.18653,23.09122 63.95624,61.50514 z"
        style={{
          fill: "none",
          strokeWidth: "10",
          stroke: "#18181b",
          strokeDasharray: "none",
          strokeOpacity: "1",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
    </>
  );
}

export default ClothingIcon;
